import React from 'react'

type Props = {
  id: string
  name: string | undefined
  path: string[]
  type: 'product' | 'category'
}

const ItemInfoDisplay = ({ id, name, path, type }: Props) => {
  const displayName =
    name ?? (path.length > 0 ? path[path.length - 1] : 'Unknown')

  return (
    <div className="flex flex-col gap-2 mb-4 text-sm text-coolGray-500">
      {path.length > 0 && (
        <div
          className="inline-flex items-center gap-0.5 text-gold-700 text-xxs flex-wrap"
          aria-label="Category path"
        >
          {path.map((pathItem, i) => (
            <React.Fragment key={pathItem}>
              <div className="break-words">{pathItem}</div>
              {i < path.length - 1 && <span aria-hidden="true">/</span>}
            </React.Fragment>
          ))}
        </div>
      )}
      <div className="flex justify-between items-center">
        <div className="break-words font-medium text-base text-base-700">
          {displayName}
        </div>
        {type === 'product' && (
          <div className="break-words text-gold-900 text-sm">
            <span>ID:</span>
            {id}
          </div>
        )}
      </div>
    </div>
  )
}

export default ItemInfoDisplay
